
import position from 'components/common/hoc/position'
import SpecificationsSection from './SpecificationsSection'

export default position(SpecificationsSection)

